import * as actionTypes from './actionTypes';
import axios from "axios";
import api from '../../utilities/api';
import { getMessage } from '../../utilities/getMessage';

export const deletePartnerCommission=(id,token)=>async dispatch=>{
    dispatch({
        type:actionTypes.DELETE_PARTNER_COMMISSION_START
    })
    const options={
        url:`${api}/partnerCommissions/${id}`,
        method:'DELETE',
        headers:{
            'Authorization':`Bearer ${token}`
        },
        data:{}
    }
    await axios(options)
            .then(response=>dispatch({
                type:actionTypes.DELETE_PARTNER_COMMISSION_SUCCESS,
                payload:id
            }))
            .catch(error=>dispatch({
                type:actionTypes.DELETE_PARTNER_COMMISSION_FAIL,
                payload:getMessage(error)
            }))
}